// extracted by mini-css-extract-plugin
module.exports = {"callArea":"styles_callArea__B9FTU","phoneSvg":"styles_phoneSvg__7hSRd","contact":"styles_contact__UP9ug"};